// Module
var code = "<h4>Comments</h4> <div class=commentsList></div> <div class=\"noCommentsMsg panel\" style=display:none> <div class=\"panel-content text-center text-muted\"> No comments yet! Be the first! </div> </div> <div class=commentsForm></div> ";
// Exports
module.exports = code;